<p-button type="button" [text]="true" [pt]="pt()" (onClick)="menu.toggle($event)" data-cy="help-button">
    <fa-icon [icon]="faCircleQuestion" class="scale-[1.8] p-1 text-(--p-azara-white-100)" data-cy="help-icon"></fa-icon>
</p-button>
<p-menu
    #menu
    [model]="helpMenu"
    [popup]="true"
    [pt]="menuPt"
    appendTo="body"
    styleClass="help-menu"
    data-cy="help-menu"
>
    <ng-template #item let-item>
        <a
            class="p-menu-item-link"
            [attr.href]="item.url || null"
            [attr.target]="item.target || null"
            [attr.rel]="item.target === '_blank' ? 'noopener' : null"
            data-cy="help-menu-item"
        >
            <div class="p-menu-item-icon" data-cy="help-menu-item-icon">
                <fa-icon [icon]="item.faIcon" class="fa-xl"></fa-icon>
            </div>

            <div class="p-menu-item-text" data-cy="help-menu-item-text">
                <div class="fw-600" data-cy="help-menu-item-title">{{ item.label }}</div>
                @if (item.sub) {
                    <small class="block" data-cy="help-menu-item-subtitle">{{ item.sub }}</small>
                }
            </div>

            @if (item.right) {
                <div class="ml-auto" data-cy="help-menu-item-right">
                    @for (text of item.right; track $index) {
                        <small class="block" data-cy="help-menu-item-right-text">{{ text }}</small>
                    }
                </div>
            }

            @if (item.external) {
                <fa-icon
                    [icon]="faArrowUpRightFromSquare"
                    class="c-blue-650 ml-auto"
                    data-cy="help-menu-external-icon"
                />
            }
        </a>
    </ng-template>
</p-menu>
